"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var interfaceScale_1 = require("stremio/common/interfaceScale");
var CLOSE_THRESHOLD = 100;
var CLOSE_THRESHOLD_RATIO = 0.12;
var DISMISS_START_DELTA = 8;
var createDragState = function () { return ({
    id: null,
    startX: 0,
    startY: 0,
    offset: 0,
    dismissing: false,
    locked: false,
    scroller: null,
}); };
var isVerticallyScrollable = function (element) {
    var overflowY = window.getComputedStyle(element).overflowY;
    if (overflowY !== 'auto' && overflowY !== 'scroll' && overflowY !== 'overlay') {
        return false;
    }
    return element.scrollHeight > element.clientHeight + 1;
};
var findScrolledAncestor = function (target, container) {
    var element = target instanceof Element ? target : null;
    while (element && element !== container) {
        if (isVerticallyScrollable(element) && element.scrollTop > 1) {
            return element;
        }
        element = element.parentElement;
    }
    return null;
};
var useSheetDrag = function (_a) {
    var containerRef = _a.containerRef, enabled = _a.enabled, isExiting = _a.isExiting, onDismiss = _a.onDismiss;
    var dragRef = (0, react_1.useRef)(createDragState());
    var _b = (0, react_1.useState)(0), offset = _b[0], setOffset = _b[1];
    var _c = (0, react_1.useState)(false), dragging = _c[0], setDragging = _c[1];
    var reset = (0, react_1.useCallback)(function () {
        dragRef.current = createDragState();
        setDragging(false);
        setOffset(0);
    }, []);
    (0, react_1.useEffect)(function () {
        var node = containerRef.current;
        if (!enabled || node === null) {
            return undefined;
        }
        var onTouchStart = function (event) {
            if (isExiting() || event.touches.length !== 1) {
                return;
            }
            var touch = event.touches[0];
            dragRef.current = {
                id: touch.identifier,
                startX: touch.clientX,
                startY: touch.clientY,
                offset: 0,
                dismissing: false,
                locked: false,
                scroller: findScrolledAncestor(event.target, node),
            };
        };
        var onTouchMove = function (event) {
            var drag = dragRef.current;
            var touch = Array.from(event.touches).find(function (_a) {
                var identifier = _a.identifier;
                return identifier === drag.id;
            });
            if (!touch || isExiting() || drag.locked) {
                return;
            }
            var deltaX = touch.clientX - drag.startX;
            var deltaY = touch.clientY - drag.startY;
            if (!drag.dismissing) {
                if (Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY)) {
                    drag.locked = true;
                    return;
                }
                if (deltaY < DISMISS_START_DELTA) {
                    return;
                }
                if (drag.scroller !== null && drag.scroller.scrollTop > 1) {
                    return;
                }
                drag.dismissing = true;
                drag.startY = touch.clientY;
                drag.offset = 0;
                setDragging(true);
                event.preventDefault();
                return;
            }
            event.preventDefault();
            var nextOffset = Math.max(0, (touch.clientY - drag.startY) / (0, interfaceScale_1.getInterfaceScale)());
            drag.offset = nextOffset;
            setOffset(nextOffset);
        };
        var onTouchEnd = function (event) {
            var drag = dragRef.current;
            if (drag.id === null || event.touches.length > 0) {
                return;
            }
            var shouldClose = drag.dismissing && drag.offset > Math.max(CLOSE_THRESHOLD, (0, interfaceScale_1.getInterfaceRect)(node).height * CLOSE_THRESHOLD_RATIO);
            if (shouldClose) {
                onDismiss();
                return;
            }
            reset();
        };
        node.addEventListener('touchstart', onTouchStart, { passive: true });
        node.addEventListener('touchmove', onTouchMove, { passive: false });
        node.addEventListener('touchend', onTouchEnd);
        node.addEventListener('touchcancel', onTouchEnd);
        return function () {
            node.removeEventListener('touchstart', onTouchStart);
            node.removeEventListener('touchmove', onTouchMove);
            node.removeEventListener('touchend', onTouchEnd);
            node.removeEventListener('touchcancel', onTouchEnd);
        };
    }, [containerRef, enabled, isExiting, onDismiss, reset]);
    return { offset: offset, dragging: dragging, reset: reset };
};
exports.default = useSheetDrag;
